import { useRef } from "react";

const DateRangePicker = ({ dateRange, onDateChange }) => {
  const maxDateRef = useRef(null);

  const handleminDateChange = (e) => {
    onDateChange({ ...dateRange, minDate: e.target.value });
    setTimeout(() => {
      if (maxDateRef.current) {
        maxDateRef.current.showPicker?.();
        maxDateRef.current.focus();
      }
    }, 0);
  };

  const handlemaxDateChange = (e) => {
    onDateChange({ ...dateRange, maxDate: e.target.value });
  };

  return (
    <div className="mb-2 flex gap-2">
      <input
        type="date"
        className="input input-bordered w-full"
        value={dateRange.minDate || ""}
        onChange={handleminDateChange}
        placeholder="Start date"
      />
      <span className="self-center">to</span>
      <input
        ref={maxDateRef}
        id="end-date-input"
        type="date"
        className="input input-bordered w-full"
        value={dateRange.maxDate || ""}
        min={dateRange.minDate || ""}
        onChange={handlemaxDateChange}
        placeholder="End date"
      />
    </div>
  );
};

export default DateRangePicker;
